import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { resources } from "./locales/resources";

const supportedLngs = ["en", "ro", "tr", "it", "is"] as const;

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs,
    defaultNS: "translation",
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "youngreenteco.language"
    },
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

document.documentElement.lang = i18n.resolvedLanguage || "en";

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
